import React, { Component } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { CssBaseline, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { GitHub } from '@mui/icons-material';

type HeaderProps = {

}

type HeaderState = {
    menuOpen: boolean
}

class Header extends Component<HeaderProps, HeaderState> {
    constructor(props: HeaderProps) {
        super(props)
        this.state = {
            menuOpen: false,
        }
        this.openMenu = this.openMenu.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
    }

    openMenu() {
        this.setState((state, props) => ({
            menuOpen: true
        }));
    }

    closeMenu() {
        this.setState((state, props) => ({
            menuOpen: false
        }));
    }

    render(){
        return(<>
            <Drawer open={this.state.menuOpen} onClose={this.closeMenu}>
                <Box sx={{ width: 250 }} role="presentation" onClick={this.closeMenu}>
                    <List>
                        <ListItem>
                            <ListItemButton href="https://www.github.com/domilopment">
                                <ListItemIcon>
                                    <GitHub />
                                </ListItemIcon>
                                <ListItemText primary={"My GitHub"} />
                            </ListItemButton>
                        </ListItem>
                        <Divider />
                        <ListItem>
                            <ListItemButton href="https://www.github.com/sadoke">
                                <ListItemIcon>
                                    <GitHub />
                                </ListItemIcon>
                                <ListItemText primary={"SaDoKe"} />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Box>
            </Drawer>
            <Box sx={{ display: 'flex' }}>
                <CssBaseline />
                <AppBar position="sticky" style={{ background: "linear-gradient(to right, darkturquoise, darkorchid)" }} >
                    <Toolbar>
                        <IconButton
                            onClick={this.openMenu}
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                        >
                            <MenuIcon />
                        </IconButton>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Domilopment
                        </Typography>
                    </Toolbar>
                </AppBar>
             </Box>
        </>);
    }
}

export default Header;